import { FileIcon, FileImageIcon, FileTextIcon, GlobeIcon, type LucideIcon } from "lucide-react";
import type { Attachment } from "../../../../shared/api.ts";
import { useI18n } from "@/i18n/index.tsx";
import { cn, openFile } from "@/lib/utils.ts";

export const ATTACHMENT_ICONS: Record<Attachment["kind"], LucideIcon> = {
  pdf: FileTextIcon,
  image: FileImageIcon,
  file: FileIcon,
  page: GlobeIcon,
};

/** A file attached to a message: icon by kind, name, and size. Clicking opens the file. */
export function AttachmentChip({ attachment, className }: { attachment: Attachment; className?: string }) {
  const { t, fmt } = useI18n();
  const Icon = ATTACHMENT_ICONS[attachment.kind];
  return (
    <button
      type="button"
      onClick={() => openFile(attachment.url)}
      title={`${t.session.openFile}: ${attachment.name}`}
      className={cn(
        "inline-flex h-8 max-w-full min-w-0 items-center gap-2 rounded-lg border bg-card px-2.5 text-left text-[12.5px] transition-colors hover:border-border-strong hover:bg-accent focus-visible:ring-[3px] focus-visible:ring-ring/35 focus-visible:outline-none",
        className,
      )}
    >
      <Icon className={cn("size-4 shrink-0", attachment.kind === "pdf" ? "text-danger" : "text-primary")} aria-hidden />
      <span className="min-w-0 truncate font-medium">{attachment.name}</span>
      <span className="code-mono shrink-0 text-[11px] text-muted-foreground">{fmt.bytes(attachment.bytes)}</span>
    </button>
  );
}
